module.exports = __webpack_public_path__ + "img/product-2.50bb20f4.png";